const GroupRMBoxIntegrated = ({language , token}) => {
    const newGroupRMBoxIframe = "https:" +
    window.process.env.URL_Boitier_GroupeRmbox
    +  "?lang=" + language + "&token=" +
      token
  
    return (
      <iframe
        id="iframe_groupRMBox_display"
        src={newGroupRMBoxIframe}
        allowFullScreen
        frameBorder={"0"}
        style={{ width: '100%', height: '100%', overflow: 'hidden' }}
      />
    );
  };
  
  export default GroupRMBoxIntegrated